var Reverb = window.Reverb || {};

Reverb.Animations = function () {
  function init() {
    $('.animate-on-load').addClass('run-animation');
  }

  return {
    init: init
  };
}();

$(Reverb.Animations.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/animations.js